<i class="material-icons justify-center m-auto" [ngClass]="iconClass" aria-hidden="true"></i>